var _circle, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _ellipse, _circle2, _ellipse2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportsGolfCartGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#EBECEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9067 16.0217L60.2991 41.4364L62.4892 40.8488L53.6061 16.0217H50.9067Z",
    fill: "#505862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.591 37.3392L62.7588 47.6948C63.0494 47.9643 63.1273 48.3932 62.9501 48.7477L62.6772 49.2934C62.4109 49.8259 61.7076 49.953 61.2718 49.5473L49.8169 38.8824C49.6891 38.7634 49.5292 38.6845 49.357 38.6556L47.1277 38.2809C46.8433 38.233 46.5532 38.3258 46.3492 38.5297L45.3847 39.4943C45.0275 39.8514 44.4454 39.841 44.1013 39.4714L43.9301 39.2876C43.6093 38.943 43.6116 38.4083 43.9354 38.0665L50.4213 31.2203C50.7959 30.8249 51.4343 30.8546 51.7705 31.2832L51.8582 31.3949C52.1109 31.717 52.1118 32.1698 51.8605 32.493L51.0221 33.5708C50.866 33.7715 50.803 34.0293 50.8489 34.2794L51.3202 36.8463C51.3549 37.0355 51.4499 37.2084 51.591 37.3392Z",
    fill: "#505862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3025 35.3085C34.3762 38.7949 40.045 42.4928 32.4167 42.4928C30.8538 42.9741 28.7164 40.5379 27.6427 37.0515C26.569 33.565 22.9177 30.4698 28.5285 29.8672C30.0914 29.3859 32.2288 31.822 33.3025 35.3085Z",
    fill: "#D5D8DD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.9731,
    y: 40.4146,
    width: 16.5748,
    height: 6.62992,
    rx: 3.31496,
    fill: "#D5D8DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5277 29.4512C21.0743 27.9935 21.6665 19.8848 21.8943 16.0127H26.382V27.1735C26.382 34.0977 31.393 42.2064 33.8985 45.3952C29.5708 45.0915 18.6144 44.3019 18.25 43.573C17.7944 42.662 19.8444 31.2734 20.5277 29.4512Z",
    fill: "#505862"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1371 43.5254C11.6794 44.8009 11.3149 47.5493 11.3149 48.7641L23.3868 51.0418L31.3588 58.786H43.794V45.6476L17.6925 41.5541C16.7815 41.3264 14.5949 42.2498 13.1371 43.5254Z",
    fill: "#9DA4AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6191 48.8116C57.9598 43.4827 58.0511 42.2327 58.8842 39.1933C58.9955 38.7869 59.3806 38.5141 59.7989 38.565C67.0708 39.4512 69.4695 45.7225 70.6463 48.8116H56.6191Z",
    fill: "#9DA4AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7652 18.5615C20.1914 16.4881 22.0165 15 24.1332 15H51.5281C53.336 15 54.9651 16.0916 55.6525 17.7638L56.5301 19.8986C56.7714 20.4855 56.3399 21.1296 55.7052 21.1296H20.3312C19.7664 21.1296 19.3438 20.6113 19.4575 20.0581L19.7652 18.5615Z",
    fill: "#B9BEC6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6989 57.6948H8.89187C8.39931 57.6948 7.99774 57.2946 8.02168 56.8027C8.2443 52.2273 10.1292 48.8284 11.2398 47.7538C11.352 47.6453 11.4976 47.583 11.6522 47.562C12.3105 47.4723 12.3042 47.597 20.8907 47.597C26.5342 47.597 30.8134 51.3508 32.1432 54.4469C32.2975 54.8061 32.6381 55.0631 33.0291 55.0631H54.2077C54.629 55.0631 54.9928 54.7684 55.0802 54.3563L56.3641 48.3038C56.4515 47.8918 56.8122 47.597 57.2335 47.597H70.3171C74.6448 47.597 76.9515 55.8636 74.9143 55.8636C72.9575 55.8636 69.7026 58.4176 66.7415 58.4176C60.7953 58.4176 59.2337 57.6573 58.1266 60.0773C57.9708 60.4178 57.6423 60.6558 57.2679 60.6558H30.2312C29.7673 60.6558 29.3841 60.2989 29.3188 59.8396C28.6003 54.7862 25.208 51.0894 19.8441 51.0894C14.7596 51.0894 13.1824 54.7187 12.5858 56.9941C12.4791 57.4009 12.1195 57.6948 11.6989 57.6948Z",
    fill: "#505862"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7073,
    cy: 59.7518,
    rx: 9.39239,
    ry: 9.39239,
    fill: "#67717E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7072,
    cy: 59.7518,
    r: 5.83851,
    fill: "#B9BEC6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.8624,
    cy: 59.4972,
    rx: 9.13779,
    ry: 9.13779,
    fill: "#67717E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8629,
    cy: 59.4974,
    r: 5.68025,
    fill: "#B9BEC6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportsGolfCartGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SportsGolfCartGray.e665e309d1491154937178557e404b5e.svg";